import React from "react";
import "./ActivityList.css";

export const ActivityList = ({
  activities,
  selectedActivity,
  onListActivityClick,
}) => {
  return (
    <div className="activity-list">
      {activities.map((activity, index) => (
        <div
          key={index}
          className={`activity-list__item ${
            activity.id === selectedActivity.id ? "active" : ""
          }`}
          onClick={() => onListActivityClick(activity)}
        >
          <div
            className="activity-list__image-container"
            style={{
              backgroundImage: `url(${activity.portrait})`,
            }}
          >
            <p className="activity-list__title">{activity.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
